module.exports = __webpack_public_path__ + "static/media/MoP_logo.3b0656e8.svg";